// client/src/components/admin/influencer/InfluencerPointAddModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function InfluencerPointAddModal({ open, onClose, influencer, onSuccess }) {
  const [points, setPoints] = useState('');
  const [memo, setMemo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setPoints('');
      setMemo('');
      setError('');
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!influencer) return;

    setError('');

    const pointAmount = Number(points);
    if (!points || isNaN(pointAmount) || pointAmount <= 0) {
      setError('지급할 포인트를 입력해주세요. (양수만 가능)');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${API_URL}/api/admin/influencer/info/${influencer.userId}/points/adjust`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ 
            amount: pointAmount, // 양수
            memo: memo.trim() || undefined
          })
        }
      );

      const data = await res.json();

      if (data.ok) {
        onSuccess && onSuccess();
        onClose();
      } else {
        setError(data.message || '포인트 지급에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('포인트 지급 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (!open || !influencer) return null;

  const currentPoints = influencer.points || 0;
  const pointAmount = Number(points) || 0;
  const expectedPoints = currentPoints + pointAmount;

  return (
    <div
      className="influencer-point-modal"
      onClick={onClose}
    >
      <div
        className="influencer-point-modal__content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="influencer-point-modal__title influencer-point-modal__title--add">포인트 지급</h3>

        {/* 현재 포인트 표시 */}
        <div className="influencer-point-modal__current">
          <div className="influencer-point-modal__current-info">
            현재 보유 포인트
          </div>
          <div className="influencer-point-modal__current-value">
            {currentPoints.toLocaleString()}pt
          </div>
        </div>

        {/* 지급 포인트 입력 */}
        <div className="influencer-point-modal__field">
          <label className="influencer-point-modal__label">
            지급할 포인트 <span className="influencer-point-modal__required">*</span>
          </label>
          <input
            type="number"
            value={points}
            onChange={(e) => setPoints(e.target.value)}
            placeholder="지급할 포인트를 입력하세요"
            min="1"
            className="influencer-point-modal__input"
          />
        </div>

        {/* 예상 포인트 표시 */}
        {pointAmount > 0 && (
          <div className="influencer-point-modal__preview">
            <div className="influencer-point-modal__preview-label">
              지급 후 예상 포인트
            </div>
            <div className="influencer-point-modal__preview-value">
              {expectedPoints.toLocaleString()}pt
              <span style={{ fontSize: 14, fontWeight: 400, color: '#666', marginLeft: 8 }}>
                (+{pointAmount.toLocaleString()}pt)
              </span>
            </div>
          </div>
        )}

        {/* 사유 입력 (선택) */}
        <div className="influencer-point-modal__field">
          <label className="influencer-point-modal__label">
            사유 (선택)
          </label>
          <textarea
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
            placeholder="포인트 지급 사유를 입력하세요 (선택사항)"
            rows={3}
            className="influencer-point-modal__textarea"
          />
        </div>

        {error && (
          <div className="influencer-point-modal__error">
            {error}
          </div>
        )}

        <div className="influencer-point-modal__actions">
          <button
            onClick={onClose}
            disabled={loading}
            className="influencer-point-modal__button"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="influencer-point-modal__button influencer-point-modal__button--add"
          >
            {loading ? '처리 중...' : '지급'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default InfluencerPointAddModal;

